import ConfigureMetricMonitor from "./ConfigureMetricMonitor";
import MonitorCadenceSelector from "./MonitorCadenceSelector";
import { ClientWorkflow, DescribeMonitorRadioGroupValues } from "@avenueops/shared-types";
import { RadioListOption, SmartForm } from "@avenueops/web-components";
import { BookmarkIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import { WorkflowAlertingConditions, WorkflowTriggerType } from "@prisma/client";
import { useEnrichmentColumns, useQueryColumns } from "context/QueryRunContext";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
  monitor: ClientWorkflow | undefined;
}

export default function AlertingConditionsSection({ monitor }: Props): JSX.Element | null {
  const { watch, control, setValue } = useFormContext();
  const workflowType = watch("_workflowType");
  const workflowTriggerType = watch("workflowTriggerType");

  const queryColumns = useQueryColumns();
  const enrichmentColumns = useEnrichmentColumns();
  const columnNames = [...queryColumns, ...enrichmentColumns];

  const workflowTypeSettings: RadioListOption<DescribeMonitorRadioGroupValues>[] = [
    {
      value: DescribeMonitorRadioGroupValues.EVENT,
      label: "Event Monitor",
      description: "Get alerted on data events.",
      icon: <BookmarkIcon className="h-6 w-6 mr-1" strokeWidth={1.5} />,
    },
    {
      value: DescribeMonitorRadioGroupValues.REPORT,
      label: "Report Monitor",
      description: "Get a report of your data on a set schedule.",
      icon: <DocumentTextIcon className="h-6 w-6 mr-1" strokeWidth={1.5} />,
    },
  ];

  return workflowTriggerType !== WorkflowTriggerType.WEBHOOK && workflowTriggerType !== WorkflowTriggerType.INTEGRATION ? (
    <div className="pt-5 rounded-xl">
      {workflowType === DescribeMonitorRadioGroupValues.REPORT || workflowType === DescribeMonitorRadioGroupValues.EVENT ? (
        <div className="flex flex-col gap-2 mb-5">
          <div className="text-lg font-medium text-gray-900">Trigger</div>
          <div className="w-full flex flex-col gap-1 sm:gap-x-2">
            <SmartForm.RadioList
              name="_workflowType"
              options={workflowTypeSettings}
              onChangeCallback={(type) => {
                setValue(
                  "alertingConditions",
                  type === DescribeMonitorRadioGroupValues.EVENT ? WorkflowAlertingConditions.NEW_ROW : WorkflowAlertingConditions.PASSTHROUGH,
                );
              }}
            />
          </div>
        </div>
      ) : null}
      <div className="flex flex-col gap-2 w-full">
        <MonitorCadenceSelector />
      </div>
      {workflowType === "METRIC" ? <ConfigureMetricMonitor monitor={monitor} columnNames={columnNames} /> : undefined}
    </div>
  ) : null;
}
